import React, { useState } from "react";
import "./Merchant.css";
import Spinner from "../../Spin/Spinner";
import { getDailytransactions } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import ProviderModal from "./ProviderModal";

function MerchantTableGrid({ inData, isLoading, startDate, endDate }) {
  const role = useSelector((store) => store.userReducer.role);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState("");
  const [transactionData, setTransactionData] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const handleUserClick = async (userId, name) => {
    setSelectedUserId(userId);
    setSelectedUserName(name);
    try {
      const data = await getDailytransactions(userId, startDate, endDate);
      setTransactionData(data);
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching transaction data", error);
    }
  };

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="scrollable-div">
          {inData &&
            inData.length > 0 &&
            inData.map((item, index) => {
              return (
                <div key={item.id} className="data-item">
                  <div className="header">
                    <p className="serial-number">S.No: {index + 1}</p>
                    <p
                      className="user-table-name"
                      onClick={() => handleUserClick(item.id, item.name)}
                    >
                      Name: {item?.alias || item?.id}
                    </p>
                    <p className="id">
                      Available Balance:{" "}
                      {Number(item.availableBalance).toFixed(2) || "0"}
                    </p>
                  </div>
                  <div className="details">
                    <div className="detail-item">
                      <p className="heading">Deposit (INR)</p>
                      <p className="value">
                        {Number(item.payin).toFixed(2) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Payin Success Rate (%)</p>
                      <p className="value">
                        {Number(item.payinSuccRate).toFixed(2) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Payin Comm (INR)</p>
                      <p className="value">
                        {Number(item.payinComm).toFixed(2) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Total Payin Comm (%)</p>
                      <p className="value">
                        {Number(item.payinCommPer).toFixed(2) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Rolling Reserve (INR)</p>
                      <p className="value">
                        {Number(item.rollingReserve).toFixed(2) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Rolling Reserve (%)</p>
                      <p className="value">
                        {Number(item.rollingResPer).toFixed(2) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Net Payin Comm (INR)</p>
                      <p className="value">
                        {Number(item.payinNetComm).toFixed(2) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Withdrawal (INR)</p>
                      <p className="value">
                        {Number(item.payout).toFixed(2) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Payout Success Rate (%)</p>
                      <p className="value">
                        {Number(item.payoutSuccRate).toFixed(2) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Payout Comm (INR)</p>
                      <p className="value">
                        {Number(item.payoutComm).toFixed(2) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Total Payout Comm (%)</p>
                      <p className="value">
                        {Number(item.payoutCommPer).toFixed(2) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Payout Net Comm (INR)</p>
                      <p className="value">
                        {Number(item.payoutNetComm).toFixed(2) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Recon Amount (INR)</p>
                      <p className="value">
                        {Number(item.reconAmount).toFixed(2) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Total Penalty (INR)</p>
                      <p className="value">
                        {Number(item.recontotalPenalty).toFixed(2) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Available Balance (INR)</p>
                      <p className="value">
                        {Number(item.availableBalance).toFixed(2) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Wallet Balance (INR)</p>
                      <p className="value">
                        {Number(item.walletBalance).toFixed(2) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Net Amount 12AM-5AM (INR)</p>
                      <p className="value">
                        {Number(item.payinTimeBreakdown?.time_12am_5am).toFixed(
                          2
                        ) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Net Amount 5AM-7AM (INR)</p>
                      <p className="value">
                        {Number(item.payinTimeBreakdown?.time_5am_7am).toFixed(
                          2
                        ) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Net Amount 7AM-1PM (INR)</p>
                      <p className="value">
                        {Number(item.payinTimeBreakdown?.time_7am_1pm).toFixed(
                          2
                        ) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Net Amount 1PM-7PM (INR)</p>
                      <p className="value">
                        {Number(item.payinTimeBreakdown?.time_1pm_7pm).toFixed(
                          2
                        ) || "0"}
                      </p>
                    </div>
                    <div className="detail-item">
                      <p className="heading">Net Amount 7PM-12AM (INR)</p>
                      <p className="value">
                        {Number(item.payinTimeBreakdown?.time_7pm_12am).toFixed(
                          2
                        ) || "0"}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      )}
      {showModal && (
        <ProviderModal
          transactionData={transactionData}
          setShowModal={setShowModal}
          startDate={startDate}
          endDate={endDate}
          userName={selectedUserName}
        />
      )}
    </>
  );
}

export default MerchantTableGrid;
